import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";
import BaseListComponent from "./../../../components/BaseListComponent";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
import {
  getCurrentUserSession,
  getCurrentUsersRoles,
} from "../../../services/auth/authService";
import collectionConsentConfigService from "../../../services/mandate/collectionConsentConfigService";
import CollectionConsentConfigDetails from "./collectionConsentConfigDetails";
import EditCollectionConsentConfig from "./editCollectionConsentConfig";
import { decodeToken } from "react-jwt";

export interface CollectionConsentConfigProps {}

export interface CollectionConsentConfigState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
  allItems: any;
  showPatchModal: boolean;
}

class CollectionConsentConfigList extends BaseListComponent<CollectionConsentConfigState> {}

class CollectionConsentConfig extends React.Component<
  CollectionConsentConfigProps,
  CollectionConsentConfigState
> {
  _isMounted = false;
  constructor(props: CollectionConsentConfigProps) {
    super(props);
    this.state = {
      data: createFilterData([
        "repaymentBank",
        "bankCode",
      ]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "repaymentBank", fieldType: "text", value: "" },
        { name: "bankCode", fieldType: "text", value: "" },
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
      showPatchModal: false,
      allItems: [],
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    // const decodedToken = decodeToken(getCurrentUserSession().token || "");
    data = typeof data === "undefined" ? this.state.data : data;
    try {
      const collectionConsentConfig =
        await collectionConsentConfigService.filterCollectionConsentConfig(
          data,
          pageSize,
          currentPage
        );
      this.setState({
        tableItems: mapEntityList({
          entityList: collectionConsentConfig.data.item2,
          properties: [
            { oldName: "repaymentBank", newName: "repaymentBank" },
            { oldName: "bankCode", newName: "bankCode" }
          ],
        }),
        currentPage,
        pageSize,
        totalSize: collectionConsentConfig.data.item1,
        fetching: false,
      });
    } catch (ex) {
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        this.setState({ fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        this.setState({ fetching: false });
      }
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleOnExport = async (type: string) => {};

  onTogglePatchModal = () => {
    this.setState({
      showPatchModal: !this.state.showPatchModal,
      showDetailsModal: !this.state.showDetailsModal,
    });
  };

  fetchItemById = async (item: any) => {
    const decodedToken = decodeToken(getCurrentUserSession().token || "");
    this.setState({ fetchingDetail: true });
    const collectionConsentConfig =
      await collectionConsentConfigService.retrieveCollectionConsentConfigById(
        item.id
      );
    this.setState({
      item: collectionConsentConfig.data,
      fetchingDetail: false,
    });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      // data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    // console.log("asfsdf", this.state.filterValueInput);
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Collection Consent Config</b>
              </h3>
            </div>
            <CollectionConsentConfigList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              //   updateState={this.state.updateBaseListState}
              initialValues={{
                data: createFilterData([
                  "repaymentBank",
                  "bankCode",
                ]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: this.state.filterValueInput,
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
              }) => (
                <Fragment>
                  <CollectionConsentConfigDetails
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    showTrail={null}
                    currentUserRoles={getCurrentUsersRoles()}
                    item={item}
                    togglePatchModal={() => {
                      this.onTogglePatchModal();
                      onToggleDetailsModal();
                    }}
                  />
                  <EditCollectionConsentConfig
                    showEditModal={showEditModal}
                    toggleEditModal={(reloadDetails: boolean, item: any) => {
                      onToggleEditModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(item);
                      }
                      this.setState({
                        showDetailsModal: !this.state.showDetailsModal,
                      });
                    }}
                    item={item}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="Collection Consent Config"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></CollectionConsentConfigList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CollectionConsentConfig;
